const productionPublicApiKey = "api_public_cXW3WKnJU6anYaQZrDuBEzilP2D62Bm0WLedtAkte9oYtX2HXFcmX0SyJEt6JDd8";
const developmentPublicApiKey = "api_public_SWjKgZS4mFBmNDZiPokAmj0knQTYRHRvXpY2bnXDRbiB091leb68g6FVTQOXEtVB";

const productionOnboardingFlowId = "flow_5ULL1WTAs1kNGqoF";
const developmentOnboardingFlowId = "flow_Kn3NN9CmVRketdUx";

const config = {
  defaultAppearance: {
    theme: {
      colorText: "var(--color-text)",
      colorTextSecondary: "var(--color-text-soft)",
      colorTextOnPrimaryBackground: "var(--color-text-on-primary)",
      colorPrimary: "var(--color-primary)",
      colorBorder: "var(--color-border)",
      colorBackground: "var(--color-background-modal)",
      fontSize: "var(--font-size)",
    },
    styleOverrides: {
      modalContainer: {
        borderRadius: "var(--border-radius-4)",
      },
      mediumTitle: {
        marginBottom: "var(--m-xs)",
      },
      mediumSubtitle: {
        marginBottom: "var(--m)",
      },
    },
  },
};

export { productionPublicApiKey, developmentPublicApiKey, productionOnboardingFlowId, developmentOnboardingFlowId, config };
